( function ( _s ) {
	_s.fn.newPasswordForm = function () {
		return this.each( el => {
			const _self = _s( el );
			const _newPassword = _self.find( '[name="new_password"]' );
			const newPassword = _newPassword.firstElement();

			const addError = () => {
				newPassword.setAttribute( 'aria-invalid', 'true' );

				if ( ! _self.find( '.error-message' ).length ) {
					_newPassword.after(
						'<span class="error-message">Password does not meet the minimum requirements</span>'
					);
				}
			};

			const removeError = () => {
				newPassword.setAttribute( 'aria-invalid', 'false' );
				_self.find( '.error-message' ).remove();
			};

			const validatePassword = () => {
				let valid = true;
				const regex =
					/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

				if ( ! newPassword.value.length ) {
					valid = false;
				}

				if ( newPassword.value.length > 0 && ! regex.test( newPassword.value ) ) {
					valid = false;
				}

				return valid;
			};

			if ( _newPassword.length ) {
				_self.on( 'submit', e => {
					if ( ! validatePassword() ) {
						e.preventDefault();
						addError();
					} else {
						removeError();
					}
				} );

				_newPassword.on( 'blur', () => {
					const valid = validatePassword();

					if ( valid ) {
						removeError();
					} else {
						addError();
					}
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '.new-password-form.module form' ).newPasswordForm();
	} );
} )( window._s );
